import { Icon, Tooltip, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { SkeletonLoaders } from '@hero/components';
import { useGetDashboardSummary } from '@hero/services/order-service/hook';

import * as S from './style';

function DashboardAnalytics() {
  const { t } = useTranslation();

  const { data, isLoading } = useGetDashboardSummary();

  return (
    <S.DashboardAnalyticsWrapper>
      {isLoading && (
        <S.DashboardAnalyticsGroup isLoading={isLoading}>
          <SkeletonLoaders.DataDashboardAnalytics itemCount={3} />
        </S.DashboardAnalyticsGroup>
      )}
      {isLoading && (
        <S.DashboardAnalyticsGroup isLoading={isLoading}>
          <SkeletonLoaders.DataDashboardAnalytics itemCount={2} />
        </S.DashboardAnalyticsGroup>
      )}
      {!isLoading && (
        <>
          <S.DashboardAnalyticsGroup>
            <S.DashboardAnalyticsItem>
              <S.DashboardAnalyticsItemCount>
                <Icon size="lg" name={'gift-box'} color="var(--color-accent-primary-default)" />
                <Typography variant="subtitle3Bold">{data?.liveRecognitionCount}</Typography>
              </S.DashboardAnalyticsItemCount>

              <S.DashboardAnalyticsItemInfo>
                <Tooltip
                  tooltipConfig={{ placement: 'bottom', offset: [35, 0] }}
                  content={
                    <Trans i18nKey={'activeRecognitionsTooltip'} components={{ b: <b /> }} />
                  }
                >
                  <Icon size="md" name="info" color="var(--color-fg-weak)" />
                </Tooltip>
                <Typography variant="caption1" emphasis="weak">
                  {t('activeRecognitions')}
                </Typography>
              </S.DashboardAnalyticsItemInfo>
            </S.DashboardAnalyticsItem>
            <VerticalDivider style={{ margin: '0 var(--size-16)' }} />

            <S.DashboardAnalyticsItem>
              <S.DashboardAnalyticsItemCount>
                <Icon
                  size="lg"
                  name={'automation-outline'}
                  color="var(--color-accent-primary-default)"
                />
                <Typography variant="subtitle3Bold">{data?.activeAutomationCount}</Typography>
              </S.DashboardAnalyticsItemCount>

              <S.DashboardAnalyticsItemInfo>
                <Tooltip
                  content={<Trans i18nKey={'activeAutomationsTooltip'} components={{ b: <b /> }} />}
                >
                  <Icon size="md" name="info" color="var(--color-fg-weak)" />
                </Tooltip>
                <Typography variant="caption1" emphasis="weak">
                  {t('activeAutomations')}
                </Typography>
              </S.DashboardAnalyticsItemInfo>
            </S.DashboardAnalyticsItem>
            <VerticalDivider style={{ margin: '0 var(--size-16)' }} />
            <S.DashboardAnalyticsItem>
              <S.DashboardAnalyticsItemCount>
                <Icon
                  size="lg"
                  name={'unredeemed-gift'}
                  color="var(--color-accent-primary-default)"
                />
                <Typography variant="subtitle3Bold">{data?.unclaimedGiftCount}</Typography>
              </S.DashboardAnalyticsItemCount>

              <S.DashboardAnalyticsItemInfo>
                <Tooltip
                  content={<Trans i18nKey={'unclaimedGiftsTooltip'} components={{ b: <b /> }} />}
                >
                  <Icon size="md" name="info" color="var(--color-fg-weak)" />
                </Tooltip>
                <Typography variant="caption1" emphasis="weak">
                  {t('unclaimedGifts')}
                </Typography>
              </S.DashboardAnalyticsItemInfo>
            </S.DashboardAnalyticsItem>
          </S.DashboardAnalyticsGroup>
          <S.DashboardAnalyticsGroup>
            <S.DashboardAnalyticsItem>
              <S.DashboardAnalyticsItemCount>
                <Icon size="lg" name={'contacts'} color="var(--color-accent-primary-default)" />
                <Typography variant="subtitle3Bold">{data?.lifetimeEngament}%</Typography>
              </S.DashboardAnalyticsItemCount>

              <S.DashboardAnalyticsItemInfo>
                <Tooltip
                  content={
                    <Trans i18nKey={'lifetimeEngagementTooltip'} components={{ b: <b /> }} />
                  }
                >
                  <Icon size="md" name="info" color="var(--color-fg-weak)" />
                </Tooltip>
                <Typography variant="caption1" emphasis="weak">
                  {t('lifetimeEngagement')}
                </Typography>
              </S.DashboardAnalyticsItemInfo>
            </S.DashboardAnalyticsItem>

            <VerticalDivider style={{ margin: '0 var(--size-16)' }} />

            <S.DashboardAnalyticsItem>
              <S.DashboardAnalyticsItemCount>
                <Icon size="lg" name={'confetti'} color="var(--color-accent-primary-default)" />
                <Typography variant="subtitle3Bold">{data?.acceptedOrderCount}</Typography>
              </S.DashboardAnalyticsItemCount>

              <S.DashboardAnalyticsItemInfo>
                <Tooltip
                  content={
                    <Trans i18nKey={'lifetimeRedemptionsTooltip'} components={{ b: <b /> }} />
                  }
                >
                  <Icon size="md" name="info" color="var(--color-fg-weak)" />
                </Tooltip>
                <Typography variant="caption1" emphasis="weak">
                  {t('lifetimeRedemptions')}
                </Typography>
              </S.DashboardAnalyticsItemInfo>
            </S.DashboardAnalyticsItem>
          </S.DashboardAnalyticsGroup>
        </>
      )}
    </S.DashboardAnalyticsWrapper>
  );
}

export { DashboardAnalytics };
